import { gql } from '@apollo/client';
import { BASE_SITE_FRAGMENT, SITE_FRAGMENT } from 'graphql/secure/fragments/site.fragments';
import { ACTIVITY_LIST_FRAGMENT } from '../fragments/activity.fragments';
import { DOCUMENT_FRAGMENT } from '../fragments/document.fragments';

export const GET_SITES = gql`
  query GetSites(
    $first: Int
    $after: String
    $filters: SitesFilters
    $summaryFilters: SitesSummaryFilters
    $siteViewOption: SiteViewOption
    $orderBy: SitesOrderBy
  ) {
    sites(
      first: $first
      after: $after
      filters: $filters
      siteViewOption: $siteViewOption
      orderBy: $orderBy
    ) {
      count
      edges {
        node {
          ...baseSiteValues
        }
      }
      summary(filters: $summaryFilters) {
        farmsCount
        plotsCount
        plotsSizeHa
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${BASE_SITE_FRAGMENT}
`;

export const GET_SITE_OVERVIEW = gql`
  query GetSiteOverview($id: UUID!, $lang: Language) {
    site(id: $id, lang: $lang) {
      ...siteValues
    }
    activities(first: 3, filters: { siteId: $id }) {
      edges {
        node {
          ...activityListValues
        }
      }
    }
    documents(first: 3, filters: { siteIds: [$id] }) {
      edges {
        node {
          ...documentValues
        }
      }
      count
    }
    sharedDocuments(first: 3, filters: { siteIds: [$id] }) {
      edges {
        node {
          ...documentValues
        }
      }
      count
    }
  }
  ${SITE_FRAGMENT}
  ${DOCUMENT_FRAGMENT}
  ${ACTIVITY_LIST_FRAGMENT}
`;

export const GET_SITE = gql`
  query GetSite($id: UUID!, $lang: Language) {
    site(id: $id, lang: $lang) {
      ...siteValues
    }
  }
  ${SITE_FRAGMENT}
`;

/**
 * Get all the site ids of a cluster site
 * Warn: This query is not paginated and should only be called for site type cluster
 */
export const GET_CLUSTER_SITE_IDS = gql`
  query GetClusterSiteIds($id: UUID!) {
    site(id: $id) {
      ... on SiteCluster {
        id
        sites {
          count
          edges {
            node {
              ... on Farm {
                id
              }
              ... on GenericSite {
                id
              }
              ... on Mine {
                id
              }
              ... on Forest {
                id
              }
              ... on OriginSite {
                id
              }
              ... on CollectionSite {
                id
              }
              ... on Plant {
                id
              }
              ... on ProcessingSite {
                id
              }
              ... on Factory {
                id
              }
              ... on ManufacturingSite {
                id
              }
              ... on Warehouse {
                id
              }
              ... on HandlingSite {
                id
              }
              ... on GroceryStore {
                id
              }
              ... on DistributionSite {
                id
              }
            }
          }
        }
      }
    }
  }
`;
